import { useState } from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@shared/ui/card";
import { Button } from "@shared/ui/button";
import { Plus } from "lucide-react";
import { TransferTypesTable } from "./transferLanding/transferLanding";
import { TransferTypeDialog } from "./transferAdd/transferAdd";

export function TransferSettings() {
  const [showDialog, setShowDialog] = useState(false);
  const [editingType, setEditingType] = useState(null);

  const handleAddType = () => {
    setEditingType(null);
    setShowDialog(true);
  };

  const handleEditType = (type: any) => {
    setEditingType(type);
    setShowDialog(true);
  };

  const handleCloseDialog = () => {
    setShowDialog(false);
    setEditingType(null);
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <p className="card-heading-text">Transfer Types Configuration</p>

            <p className="page-subtitle">
              Configure transfer types with their timing requirements,
              priorities, and SLA settings
            </p>
        </div>
        <Button onClick={handleAddType}>
          <Plus className="mr-2 h-4 w-4" />
          Add Transfer Type
        </Button>
      </div>
      <TransferTypesTable onEditType={handleEditType} />

      <TransferTypeDialog
        open={showDialog}
        onOpenChange={setShowDialog}
        type={editingType}
        onClose={handleCloseDialog}
      />
    </div>
  );
}
